import React from 'react';
import { IconProps } from '../IconProps';

const SvgLogout = ({
  primaryColor,
  secondaryColor,
  tertiaryColor,
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none" {...props}>
    <g clipPath="url(#Logout_svg__clip0_158_3398)" fill={primaryColor}>
      <path d="M11.78 5.47L9.53 3.22a.75.75 0 10-1.061 1.061l.97.97H6.75a.75.75 0 000 1.5h2.689l-.97.97a.75.75 0 001.06 1.061l2.25-2.25a.75.75 0 000-1.061l.001-.001z" />
      <path d="M7.353 9.269a.743.743 0 00-.867.61.746.746 0 01-.735.621H2.822l1.049-.874c.4-.333.63-.823.63-1.344V3.718c0-.521-.229-1.011-.63-1.344L2.822 1.5h2.929c.363 0 .673.261.735.621a.749.749 0 101.477-.257A2.243 2.243 0 005.75 0h-3.5A2.252 2.252 0 000 2.25v7.5A2.252 2.252 0 002.25 12h3.5a2.243 2.243 0 002.213-1.864.75.75 0 00-.61-.867z" />
    </g>
    <defs>
      <clipPath id="Logout_svg__clip0_158_3398">
        <path fill="#fff" d="M0 0h12v12H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogout;
